import { shouldUseDesignSystem } from '@src/utils/should-use-design-system'

import ApplePayButtonDS from './apple-pay-button-ds'
import ApplePayButtonLegacy from './apple-pay-button-legacy'

import type { ApplePayButtonProps } from './apple-pay-button.types'

// Thin router: DS build serves when the DS rollout is on, legacy SCSS otherwise. Prop contract
// is unchanged so every caller is unaffected by the branch.
const ApplePayButton = (props: ApplePayButtonProps) =>
  shouldUseDesignSystem() ? <ApplePayButtonDS {...props} /> : <ApplePayButtonLegacy {...props} />

export type { ApplePayConfig } from './apple-pay-button.types'
export default ApplePayButton
